import {connect} from 'react-redux';

import { fetchProducts } from '../actions/products';

const mapStateToProps = ({productsById}) => ({
  products: Object.values(productsById),
});

const mapDispatchToProps = dispatch => ({
  fetchAllProducts: () => 
    dispatch(fetchProducts()),
});

export const withAllProducts = connect(
  mapStateToProps,
  mapDispatchToProps,
);




// WEBPACK FOOTER //
// ./src/containers/withAllProducts.js